var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KlevuPackFetchResult } from "./hydration.js";
import { KlevuFetch, KlevuFetchOption } from "./klevuFetch.js";
import { KlevuResponseObject } from "./responseObject.js";
/**
 * Klevu SSR Fetch will do the queries, but will do not do analytical requests.
 * They need to be hydrated on frontend.
 *
 * @param queries queries to be done
 */
export function KlevuSSRFetch(queries) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield KlevuFetch(...[...queries, new KlevuFetchOption({ isSSR: true })]);
        return {
            result,
            packed: KlevuPackFetchResult(result),
            identifier: result.packProcessedFunctionsToString(),
        };
    });
}
/**
 * Hydrates result to response object from server side results.
 * Will also run sideeffects that are pending from backend request.
 *
 * @param packed Packed result on the backend side
 * @param functions queries made on the backend side
 * @returns
 */
export function KlevuSSRHydrate(packed, functions, identifier) {
    return __awaiter(this, void 0, void 0, function* () {
        return new KlevuResponseObject(packed, yield Promise.all(functions), new KlevuFetchOption({
            FEHydrate: true,
        }), identifier);
    });
}
